
















import { defineComponent, onMounted, onUnmounted, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Tooltip',
  setup() {
    const showTooltip = ref(false);
    const tooltipContainer = ref<HTMLElement | null>(null);

    const adjustTooltip = () => {
      const container = tooltipContainer.value;

      if (!container) return;

      const rect = container.getBoundingClientRect();
      const tooltip = container.querySelector('.tooltip-content') as HTMLElement;
      const maxWidth = 300 + 8 * 2;

      if (!tooltip) return;

      // maxWidth / 2 because only default position is centered
      if (
        (rect.right > window.outerWidth - maxWidth / 2 && rect.right - maxWidth < 0) ||
        (rect.left < maxWidth / 2 && rect.left + maxWidth > window.outerWidth)
      ) {
        tooltip.style.left = `-${rect.left - 16}px`;
        tooltip.style.transform = 'none';
      } else if (rect.left < maxWidth / 2) {
        tooltip.style.left = '0';
        tooltip.style.transform = 'none';
      } else if (rect.right > window.outerWidth - maxWidth / 2) {
        tooltip.style.right = '0';
        tooltip.style.left = 'auto';
        tooltip.style.transform = 'none';
      }
    };

    onMounted(() => {
      adjustTooltip();
      window.addEventListener('resize', adjustTooltip);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', adjustTooltip);
    });

    return {
      showTooltip,
      tooltipContainer,
    };
  },
});
